import _get from 'lodash/get'
import _keyBy from 'lodash/keyBy'
import loSto from '../config/loSto'
import { Loading } from '@sukiai/components'
import React, { useEffect, useState } from 'react'

import { LO_STO } from '../lib'
import { getRewriteBaseUrl } from '../helpers/rewrite'
import { fetchFeatureFlags } from '../rest/featureFlags'

const WEB_REWRITE_ACCESS_FEATURE_FLAG = 'WEB_RE_WRITE_ACCESS'

function UserExperienceRouter ({ children }) {
  const [featureFlagsLoading, setFeatureFlagsLoading] = useState(true)
  const [reWriteEnabled, setReWriteEnabled] = useState(false)
  const [reWriteUpgradeInProgress, setReWriteUpgradeInProgress] =
    useState(false)

  useEffect(() => {
    fetchFeatureFlags()
      .then((res) => {
        const featureFlags = res?.flags
        const featureFlagsByKey = _keyBy(featureFlags, 'key')
        const isReWriteAccessEnabled = _get(
          featureFlagsByKey,
          `${WEB_REWRITE_ACCESS_FEATURE_FLAG}.enabled`,
          false
        )
        setReWriteEnabled(isReWriteAccessEnabled)
      })
      .catch((err) => {
        console.log('Error', err)
      })
      .finally(() => {
        setFeatureFlagsLoading(false)
      })
  }, [])

  useEffect(() => {
    if (reWriteEnabled) {
      try {
        setReWriteUpgradeInProgress(true)
        const rewriteTransferToken = loSto.get(LO_STO.RE_WRITE_TRANSFER_TOKEN)
        const rewriteBaseUrl = getRewriteBaseUrl()
        window.location.href = `${rewriteBaseUrl}/auth?token=${rewriteTransferToken}`
      } catch (err) {
        console.log(err)
        setReWriteUpgradeInProgress(false)
      }
    }
  }, [reWriteEnabled])

  if (featureFlagsLoading) {
    return (
      <div className='re-write-loader'>
        <Loading />
      </div>
    )
  }

  if (reWriteUpgradeInProgress) {
    return (
      <div className='re-write-loader'>
        Upgrading you to a newer experience..
      </div>
    )
  }

  return <>{children}</>
}

export default UserExperienceRouter
